import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import CommonInput from '@src/new-components/Input/CommonInput';
import { MAX_LENGTH_VOICE_NAME } from '@src/constants/voiceCloning';
import { COLOR } from '@src/styles/color';
import { Box } from '@mui/material';
import CycleBlurImage from '@src/assets/images/cycle-blur.png';
import {
  StyledInstructions,
  ContentWrapper,
  StyledInstructionsList,
} from './index.style';
import InstructionItem from './InstructionItem';

const Instructions = ({ voiceName, onVoiceNameChange, error }) => {
  const { t } = useTranslation();

  const instructions = [
    {
      title: t('recordInQuietSpace'),
      description: t('recordInQuietSpaceDesc'),
    },
    {
      title: t('startWithClearRecording'),
      description: t('startWithClearRecordingDesc'),
    },
    {
      title: t('verifyVoiceAndStart'),
      description: t('verifyVoiceAndStartDesc'),
    },
  ];
  const renderEndAdornment = () => (
    <Typography variant="body-14-regular" color={COLOR.label2[48]}>
      {voiceName?.length ?? 0}/{MAX_LENGTH_VOICE_NAME}
    </Typography>
  );
  const renderLabel = (text) => (
    <Typography variant="body-14-medium" color={COLOR.darkGray}>
      {text}
    </Typography>
  );

  return (
    <StyledInstructions>
      <img src={CycleBlurImage} alt="cycle-blue" className="cycle-blur-image" />
      <ContentWrapper>
        <Box display="flex" flexDirection="column" gap="8px">
          <Typography
            variant="heading-32-bold"
            color={COLOR.darkGray}
            align="center"
          >
            {t('createProfessionalVoiceClone')}
          </Typography>
          <Typography
            variant="body-16-regular"
            color={COLOR.label2[64]}
            align="center"
          >
            {t('howToCreateVoiceMostExpressively')}
          </Typography>
        </Box>
        <CommonInput
          label={renderLabel(t('voiceName'))}
          placeholder={t('enterVoiceName')}
          name="voiceName"
          value={voiceName}
          inputProps={{ maxLength: MAX_LENGTH_VOICE_NAME }}
          onChange={onVoiceNameChange}
          error={Boolean(error?.voiceName)}
          helperText={error?.voiceName}
          endAdornment={renderEndAdornment()}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              padding: '0px 12px 0px 0px',
              height: '40px',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
              letterSpacing: '-0.4px',
            },
          }}
        />
        <StyledInstructionsList>
          {instructions.map((instruction) => (
            <InstructionItem
              key={instruction.title}
              title={instruction.title}
              description={instruction.description}
            />
          ))}
        </StyledInstructionsList>
      </ContentWrapper>
    </StyledInstructions>
  );
};

export default Instructions;
